function cartValidation() {
  function getCart() {
    return new Promise((resolve) => {
      fetch(window.routes.cartUrl + '.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then(async (cart) => {
          const itemsWithProductData = await Promise.all(
            cart.items.map(async (item) => {
              const productResponse = await fetch(`/products/${item.handle}.js`);
              const productData = await productResponse.json();
              return { ...item, product: productData };
            }),
          );
          cart.items = itemsWithProductData;
          resolve(cart);
        });
    });
  }

  function initCartValidation(cart) {
    let itemsToRemove = [];
    if (cart.items.length > 0) {
      // First product decides if the cart is preorder or not
      const isPreorderCart = cart.items[0].product.tags.includes(window.theme.productPreorderTag);
      for (let item of cart.items) {
        if (
          (item.product.tags.includes(window.theme.productPreorderTag) && !isPreorderCart) ||
          (!item.product.tags.includes(window.theme.productPreorderTag) && isPreorderCart)
        ) {
          itemsToRemove.push(item);
        }
      }
      if (itemsToRemove.length > 0) {
        removeCartItems(itemsToRemove);
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  function prepareData(itemsToRemove) {
    let itemsToRemoveObj = { updates: {} };
    itemsToRemove.forEach((item) => {
      itemsToRemoveObj.updates[item.key] = 0;
    });

    return itemsToRemoveObj;
  }

  function removeCartItems(itemsToRemove) {
    const updates = prepareData(itemsToRemove);
    const products_titles = itemsToRemove
      .map((item) => {
        return item.product.title;
      })
      .join(', ');
    const error_message = window.languages.productFormProductsRemoved + ' ' + products_titles;

    return new Promise((resolve) => {
      fetch(''.concat(window.routes.cartUrl, '/update.js'), {
        body: JSON.stringify(updates),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then((response) => {
        response.json().then(function (content) {
          window.scrollTo({ top: 0, behavior: 'smooth' });

          sessionStorage.setItem('cartErrorMessage', error_message);
          window.location.reload();

          resolve(true);
        });
      });
    });
  }

  return new Promise((resolve, reject) => {
    getCart().then((cart) => {
      let cartValidation = initCartValidation(cart);
      if (cartValidation) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function common() {
  window.bindGoToCheckout = function () {
    let element = document.querySelector('form[action$="/cart"] button[type="submit"]');
    if (element) {
      element.addEventListener('click', (e) => {
        checkoutValidation(e);
      });
    }

    document.addEventListener('cart:change', function () {
      cartValidation().catch(() => {});
    });

    document.addEventListener('facet:update', function () {
      cartValidation().catch(() => {});
    });
  };

  function checkoutValidation(event) {
    event.preventDefault();
    event.target.disabled = true;

    cartValidation()
      .then(() => {
        event.target.disabled = false;
        if (window.routes.rootUrl == '/') {
          window.location.href = '/checkout';
        } else {
          window.location.href = window.routes.rootUrl + '/checkout';
        }
      })
      .catch(() => {
        event.target.disabled = false;
      });
  }

  function init() {
    window.bindGoToCheckout();
    checkForStoredErrorMessage();
  }

  function checkForStoredErrorMessage() {
    const storedErrorMessage = sessionStorage.getItem('cartErrorMessage');
    if (storedErrorMessage) {
      const cartErrorMessage = document.getElementById('cart-error-message');
      if (cartErrorMessage) {
        cartErrorMessage.classList.remove('hidden');
        cartErrorMessage.textContent = storedErrorMessage;
      }

      sessionStorage.removeItem('cartErrorMessage');
    }
  }

  init();
}

function docReady(fn) {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

docReady(function () {
  common();
});
